module.exports = __webpack_public_path__ + "img/delete_table.157c70b3.svg";